import React from "react";
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';

import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Label,
    LineChart,
    Line,
    CartesianGrid,
    Brush,
} from "recharts";

const DateNow = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return today =  dd+ '/' + mm + '/' + yyyy;

}
export default function OilTempChart({ OilData }) {

    OilData = [
        {
            oilTemp:5
        },
        {
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },
        {
            oilTemp:10
        },
        {
            oilTemp:10
        },
        {
            oilTemp:10
        },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },

    {
        oilTemp:10
    },
    {
        oilTemp:12
    },
    {
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },


]

    const tempData = [{
        "oilTemp": 0
      }]


    return (
        <div style={{ width: "100%", height: 180}}>
            <ResponsiveContainer>
                <AreaChart
                    data={OilData}
                    margin={{
                        top: 10,
                        right: 20,
                        left: 10,
                        bottom: 30,

                    }}
                >
                  

                    <XAxis fontSize={10} stroke ="white" dataKey={DateNow} minTickGap={150} axisLine={true} >
                        <Label
                            value='Time'
                            position='insideBottom'
                            fontSize={18}
                            fill='white'
                        />
                    </XAxis>
                    <YAxis  fontSize={18}  stroke ="white" type="number" >
                        <Label
                            value="Temp"
                            angle={-90}
                            position="insideLeft"
                            fill='white'
                            fontSize={12}

                        />
                    </YAxis>
                    <Tooltip />
                    <line
                       // dataKey="oilTemp"
                       // stroke={true} NOT A BOOLEAN
                        fillOpacity={2}
                        fill="white"
                        filter="url(#shadow)"
                    />
                    <Area
                        stroke="#66bb6a"

                        type="natural"
                        dataKey="oilTemp"
                        strokeLinecap="round"
                        fillOpacity={1}
                        fill="url(#colorUv)"
                        baseLine={[{x:0,y:-20}]}
                    />
                     {/* <Brush height={30} fill="#455a64" /> */}


                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}


function OilTempLineChart({ OilData }) {

    OilData = [
        {
            oilTemp:5
        },
        {
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },{
            oilTemp:5
        },
        {
            oilTemp:10
        },
        {
            oilTemp:10
        },
        {
            oilTemp:10
        },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },
    {
        oilTemp:10
    },

    {
        oilTemp:10
    },
    {
        oilTemp:12
    },
    {
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:12
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },{
        oilTemp:20
    },


]

    const tempData = [{
        "oilTemp": 0
      }]
    return (
        <div style={{ width: "100%", height: 250 }}>
            <ResponsiveContainer>
                <LineChart
                    data={OilData}
                    margin={{
                        top: 10,
                        right: 20,
                        left: 10,
                        bottom: 30,

                    }}
                >
                    {/* <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="15%" stopColor="#81d4fa" stopOpacity={0.7} />
                           
                        </linearGradient>
                      

                       

                    </defs> */}
                    <XAxis fontSize={10} stroke ="white" dataKey={DateNow} minTickGap={150} axisLine={true} >
                        <Label
                            value='Time'
                            position='insideBottom'
                            fontSize={18}
                            fill='white'
                        />

                    </XAxis>
                    <YAxis  fontSize={18}  stroke ="white" type="number" >
                        <Label
                            value="Temp"
                            angle={-90}
                            position="insideLeft"
                            fill='white'
                            fontSize={12}

                        />
                    </YAxis>
                    <Tooltip />
                    {/* <line
                       // dataKey="oilTemp"
                       // stroke={true} NOT A BOOLEAN
                        fillOpacity={2}
                        fill="white"
                        filter="url(#shadow)"
                    /> */}
                    <Line
                  
                        dot={false}
                        type="monotone"
                        dataKey="oilTemp"
                        strokeWidth={2}
                        // strokeLinecap="round"
                        // fillOpacity={1}
                        // fill="url(#colorUv)"
                        // baseLine={[{x:0,y:-20}]}
                    />

                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
